import { createFileRoute } from "@tanstack/react-router"
import { RoyaltiesPage } from "./-components/royalties-page"

export const Route = createFileRoute("/app/art/royalties/")({
  component: RoyaltiesPage,
})
